import { TYPO } from "styles/Typo";
import { useRef } from "react";
import StockDetailLink from "components/common/StockDetailLink";
import { TrackedLink } from "lib/analytics/react/link";
import { KOREA } from "utils/constant/ITME_INFO";

function ReletedStocks({ data }: { data: any }) {
  const containerRef = useRef<HTMLDivElement>(null);
  if (data?.length === 0) return null;

  return (
    <div
      ref={containerRef}
      className="flex items-center gap-[6px] scroll overflow-x-auto w-full px-6 "
    >
      {data?.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className="flex items-center   bg-gray10 rounded-[10px] px-2 py-[3px]"
          >
            <TrackedLink
              href={`/detail/${item?.ITEM_CD_DL}`}
              asTrace={true}
              itemspec={{
                kind: "stock",
                ticker: item?.ITEM_CD_DL,
                market: item?.LOC === KOREA ? "kr" : "us",
                rank: index + 1,
              }}
              data-gtm-id={`report-related-stocks-chip`}
            >
              <span
                className={`${TYPO.TYPO7_MD} text-gray80 whitespace-nowrap`}
              >
                {"# "}
                {item?.ITEM_KR_NM}
              </span>
            </TrackedLink>
          </div>
        );
      })}
    </div>
  );
}

export default ReletedStocks;
